module.exports = __webpack_public_path__ + "img/simplemail.930a963f.svg";